import { Caption, H2, H3, H4 } from '@/components';
import React, { useMemo, useState } from 'react';
import * as styles from './index.module.less';
import { PublicAdd, PublicMinus } from 'notta-web-icon';
import { LoadingImageUrl } from '@/constants';
import classNames from 'classnames';

const InputWrapper = ({ children, unit, className = '', ...rest }) => {
  return (
    <div className={styles.input_unit_container}>
      <div className={classNames(styles.input_wrapper, className)} style={{ ...rest }}>
        {children}
      </div>
      <p>{unit}</p>
    </div>
  );
};

const Effect = () => {
  const MONEY_SAVE = 19933;
  const HOUR_SAVE = 2.91;
  const MIN_HOUR = 0;
  const MAX_HOUR = 9999;
  const [userInputHours, setUserInputHours] = useState(10);

  const handleAddHour = () => {
    if (userInputHours >= MAX_HOUR) return;
    handleChange(String(userInputHours + 1));
  };

  const handleSubHour = () => {
    if (userInputHours <= MIN_HOUR) return;
    handleChange(String(userInputHours - 1));
  };

  const handleFocus = () => {};

  const handleChange = (value: string) => {
    value = value.replace(/(^0+)|([^\d])/g, '');
    const hour = Number(value);
    if (hour > MAX_HOUR) {
      setUserInputHours(MAX_HOUR);
      return;
    }
    setUserInputHours(Number(value));
  };

  const saveMoney = useMemo(() => {
    return userInputHours * MONEY_SAVE;
  }, [userInputHours]);

  const saveHour = useMemo(() => {
    return userInputHours * HOUR_SAVE;
  }, [userInputHours]);

  return (
    <div className={styles.effect_layout}>
      <div className={styles.title_save_container}>
        <div className={styles.effect_title_container}>
          <H2>
            Notta
            <wbr />を<wbr />
            導入
            <wbr />
            した
            <wbr />
            効果
            <wbr />
          </H2>
        </div>
        <div className={styles.save_container}>
          <div className={styles.save_block}>
            <div className={styles.save_img_container}>
              <H4>
                文字起こし
                <wbr />・<wbr />
                議事録作成
                <wbr />の<wbr />
                負担
                <wbr />と<wbr />
                コスト
                <wbr />を<wbr />
                大幅に
                <wbr />
                軽減
              </H4>
              <img
                className="lozad"
                src={LoadingImageUrl}
                data-src="https://a.storyblok.com/f/159374/1072x804/441385ff4e/compare.png"
                alt="文字起こしの工数とコストが削減"
              />
              <div className={styles.save_img_caption_container}>
                <Caption className={styles.save_img_desc}>
                  ※1. 年間1000会議でNottaを使用した削減効果、会議１回あたり1時間を想定。
                </Caption>
                <Caption className={styles.save_img_desc}>※2. 当社調べ。顧客インタビューから得られた情報。</Caption>
              </div>
            </div>
            <div className={styles.save_opera_container}>
              <H4>
                節約できる
                <wbr />
                時間とコストを
                <wbr />
                計算して
                <wbr />
                みましょう
              </H4>
              <div className={styles.opera_card}>
                {/* 转写时间输入 */}
                <div className={styles.hour_opera}>
                  <p>文字起こししたい音声データは？</p>
                  <InputWrapper unit="時間" className={styles.hour_input_wrapper}>
                    <div className={styles.hour_input_container}>
                      <button
                        aria-label="1時間引く"
                        className={userInputHours <= MIN_HOUR ? styles.input_btn_disable : styles.input_btn}
                        onClick={handleSubHour}
                      >
                        <PublicMinus />
                      </button>
                      <input
                        aria-label="文字起こししたい音声データは"
                        type="text"
                        value={userInputHours}
                        className={styles.input_container}
                        onChange={(e) => handleChange(e.target.value)}
                        onFocus={handleFocus}
                      />
                      <button
                        aria-label="1時間足す"
                        className={userInputHours >= MAX_HOUR ? styles.input_btn_disable : styles.input_btn}
                        onClick={handleAddHour}
                      >
                        <PublicAdd fill={userInputHours >= MAX_HOUR && '#B0B7BF'} />
                      </button>
                    </div>
                  </InputWrapper>
                </div>
                {/* 节省的时间 */}
                <div className={styles.save_hour}>
                  <p>Nottaで節約できる時間は？</p>
                  <InputWrapper unit="時間" background="#F8F9FA">
                    <H3>{saveHour.toLocaleString()}</H3>
                  </InputWrapper>
                </div>
                {/* 节省的钱 */}
                <div className={styles.save_money}>
                  <p>Nottaで抑えられる費用は？</p>
                  <InputWrapper unit="円" background="#F8F9FA">
                    <H3>{saveMoney.toLocaleString()}</H3>
                  </InputWrapper>
                </div>
                <p className={styles.opera_card_desc}>
                  ※1時間のテープ起こし費用は20,000円、所要時間は3時間、Nottaは73円（月額2,200円のプレミアムプランを選んだ場合）、所要時間は5分と想定。
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Effect;
